import { render } from "./DayViewWorkAreaList.vue?vue&type=template&id=68016622"
import script from "./DayViewWorkAreaList.vue?vue&type=script&lang=ts"
export * from "./DayViewWorkAreaList.vue?vue&type=script&lang=ts"
script.render = render

export default script